export const GET_SPECIAL_INFO_REQUEST = 'GET_SPECIAL_INFO_REQUEST';
export const GET_SPECIAL_INFO_SUCCESS = 'GET_SPECIAL_INFO_SUCCESS';
export const GET_SPECIAL_INFO_FAILURE = 'GET_SPECIAL_INFO_FAILURE';

export const GET_APP_DETAILS = 'GET_APP_DETAILS';
export const SET_APP_DETAILS = 'SET_APP_DETAILS';

export const GET_SPECIALLIST_TAGS = 'GET_SPECIALLIST_TAGS';
export const GET_SPECIALLIST_LIST = `GET_SPECIALLIST_LIST`;

export const GET_SPECIALLIST_BY_SOURCE = 'GET_SPECIALLIST_BY_SOURCE';
export const RESET_RESET_SPRCIAL_INFO = 'RESET_RESET_SPRCIAL_INFO';
export const GET_SPECIAL_TAGS_SUCCESS = 'GET_SPECIAL_TAGS_SUCCESS';
export const GET_SPECIAL_LIST_SUCCESS = 'GET_SPECIAL_LIST_SUCCESS';
export const GET_SPECIALLIST_BY_SOURCE_SUCCESS = 'GET_SPECIALLIST_BY_SOURCE_SUCCESS';
export const GET_SPECIAL_LIST_LOADING = 'GET_SPECIAL_LIST_LOADING';

export const SET_SPECIAL_ZAN = 'SET_SPECIAL_ZAN';
